<div class="MD-head">
  <h2>Change Password</h2>
</div>


<mat-dialog-content>
  <div class="signin-sec">
  <div><b>Your password for {{user_name}} has expired. Please reset now :</b> <br></div>
<br>
  <form class="login-box validate-form dense-2" [formGroup]="passwordForm" (ngSubmit)="onSubmit()">
    <mat-form-field class="example-full-width" appearance="outline" style="margin-bottom: 18px;">
      <mat-label>Current Password</mat-label>
      <input matInput formControlName="current_password" [type]="hide ? 'password' : 'text'" maxlength="20" required>
      <mat-icon matSuffix (click)="hide = !hide">
        {{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
      <mat-error *ngIf="passwordForm.get('password').hasError('required')">
       Current Password is required
      </mat-error>
    </mat-form-field>
    <mat-form-field class="example-full-width" appearance="outline" style="margin-bottom: 18px;">
      <mat-label>Password</mat-label>
      <input matInput formControlName="password" [type]="hide ? 'password' : 'text'" maxlength="20" required>
      <mat-icon matSuffix (click)="hide = !hide">
        {{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
      <mat-error *ngIf="passwordForm.get('password').hasError('valid') && !specialchar && !passwordForm.get('password').hasError('noMatch')">
        <div>
          Your password must include both upper and lower case characters, one number<span *ngIf="strictPasswordPolicy">, must start with an alphabet</span> and at least <span>{{data?.characterCount}}</span> characters long
        </div>
      </mat-error>
      <mat-error *ngIf="passwordForm.get('password').hasError('valid') && specialchar && !passwordForm.get('password').hasError('noMatch')">
        <div>
          Your password must include both upper and lower case characters, one special character, one number<span *ngIf="strictPasswordPolicy">, must start with an alphabet</span> and at least <span>{{data?.characterCount}}</span> characters long
        </div>
      </mat-error>
      <mat-error *ngIf="repeatedValue && passwordForm.get('password').hasError('noMatch') && !passwordForm.get('password').hasError('valid')">
        <div>
          The password should not contain first name, last name or user id
        </div>
      </mat-error>
    </mat-form-field>
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Confirm Password</mat-label>
      <input matInput formControlName="cpassword" [type]="hide ? 'password' : 'text'" maxlength="20" required>
      <mat-icon matSuffix (click)="hide = !hide" class="pwd">
        {{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
      <mat-error *ngIf="passwordForm.get('cpassword').hasError('required')">
        Password is required
      </mat-error>
    </mat-form-field>

    <button class="mr-3" mat-flat-button color="primary" type="submit">Save</button>
    <button type="button" mat-stroked-button color="accent" (click)="closedelete()">Logout</button>

  </form>

  </div>
</mat-dialog-content>
